module.exports = __webpack_public_path__ + "static/media/flutter.e760f89d.png";